import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import { Login, Signup, ForgotPassword, ResetPassword } from "./pages/Auth";
import AcceptInvite from "./pages/AcceptInvite";
import AppShell from "./components/AppShell";
import Gestion from "./pages/Gestion";
import Billing from "./pages/Billing";
import Team from "./pages/Team";
import Audit from "./pages/Audit";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div style={{minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center'}}>
        <span className="spinner" style={{borderColor:'var(--border-strong)', borderTopColor:'var(--primary)', width:32, height:32}}></span>
      </div>
    );
  }
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/app" element={<Protected><AppShell><Gestion /></AppShell></Protected>} />
      <Route path="/app/billing" element={<Protected><AppShell><Billing /></AppShell></Protected>} />
      <Route path="/app/team" element={<Protected><AppShell><Team /></AppShell></Protected>} />
      <Route path="/app/audit" element={<Protected><AppShell><Audit /></AppShell></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
